import { useAuthContext } from '../../../contexts/AuthContext'
import { faCommentSms } from '@fortawesome/free-solid-svg-icons'
import { TestSendForm, TestPageHeader } from '../../../components/alerts/TestSendForm'
import { alertsApi } from '../../../services/admin/alertsApi'
import { LocalStorageItem } from '../../../common/constants'

const PHONE_REGEX = /^\+?[1-9]\d{1,14}$/

export default function PipelineSmsTestPage() {
  const { email } = useAuthContext()
  return (
    <div className="space-y-6">
      <TestPageHeader
        mode="pipeline"
        title="Pipeline SMS"
        subtitle={
          <>
            Inserts a row into <span className="font-mono text-gray-700">active_alerts</span> flagged
            as a test. The processor polls every 30 seconds and sends via Twilio. Counts against the
            daily test-SMS quota. E.164 format required.
          </>
        }
      />

      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <TestSendForm
          mode="pipeline"
          recipientLabel="Recipient phone"
          recipientType="tel"
          recipientPlaceholder="+12403764102"
          recipientRegex={PHONE_REGEX}
          recipientInvalidMessage="Enter a valid E.164 phone number (digits only, optional leading +)."
          bodyRows={3}
          defaultBody={`Pipeline test SMS from the IoAg admin portal${email ? ` (by ${email})` : ''}.`}
          storageKey={LocalStorageItem.adminTestSmsRecipient}
          buttonLabel="Insert Pipeline Alert"
          buttonIcon={faCommentSms}
          bodyHelper="Test rows are marked isTest=true and excluded from customer reporting."
          onSend={async (params) => {
            const r = await alertsApi.pipelineSms(params)
            return {
              recipient: r.recipient,
              detail: `Row #${r.activeAlertId} inserted. Processor polls every ~${r.estimatedDeliverySeconds}s — check the Log shortly.`,
            }
          }}
        />
      </section>
    </div>
  )
}
